import { Component } from "@angular/core";
import { Geolocation } from "@ionic-native/geolocation";
import { NavController } from "ionic-angular";
import { of } from "rxjs/observable/of";
import { Hareline } from "../../models/interfaces/hareline.model";
import { HarelineAddPage } from "../../pages/hareline/hareline_add";
import { HarelineViewPage } from "../../pages/hareline/hareline_view";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";

@Component({
  selector: "page-home",
  templateUrl: "home.html",
})
export class HomePage {
  private hareline$: any;
  private hareline: Hareline;
  private hareline2: Hareline;
  private weekday: string;
  constructor(private authService: AuthService, public navCtrl: NavController,
    private db: DbserviceProvider, public geolocation: Geolocation) {
  }

  private ionViewWillEnter() {
    console.log("HomePage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    let tmpdate = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate() - 2).toISOString().substring(0, 10);
    this.weekday = new Date().toLocaleString('en-us', { weekday: 'short' });

    // This will ensure that if we have a run on Sat, e.g. Triangular Run, the switch for Tuedsday on the homepage will happen on time
    if (this.weekday === 'Tue' || this.weekday === 'Mon') {
      tmpdate = new Date(new Date().getFullYear(), new Date().getMonth() , new Date().getDate()).toISOString().substring(0, 10);
    }
    
    this.db.dbCol({
      "action": "select", "mapObject": "vw_hareline", "sqlExtended": " where hl_id = (Select min(hl_id) from hareline where hl_datetime >= '" + tmpdate + "') order by hl_datetime ",
    })
      .subscribe(
        (data: any) => {
          this.hareline = data;
          this.navCtrl.push(HarelineViewPage, {
            "hareline": this.hareline,
          });
        },
        (error) => { console.error("error", error); },
    );
  }

  private logout() {
    console.log("HomePage logout");
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts